import "./Fire.css";

function SmallFire() {
  return (
    <div className="content">
      <div className="light"></div>
      <div className="fire">
        <div className="front"></div>
      </div>
      <div className="wood">
        <div className="stick"></div>
        <div className="stick"></div>
        <div className="stick"></div>
      </div>
    </div>
  );
}

export default SmallFire;
